import { gql } from '@apollo/client';

const query = gql`
  query getFeed(
    $filter: [FeedType]
    $limit: Int
    $offset: Int
  ) {
    getFeed(
      filter: $filter
      limit: $limit
      offset: $offset
    ) {
      updates {
        ... on FeedEvent {
          id
          sources
          title
        }
      }
    }
  }
`;

export default query;
